const local_backend = "http://localhost:3333";
export const RUSSIAN_API_URL =
  process.env.REACT_APP__BACKEND_URL || local_backend;
